module.exports = __webpack_public_path__ + "img/home.b902933.png";